import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { JssProvider } from "react-jss";
import { EuiProvider } from "@elastic/eui";
import createCache from "@emotion/cache";
import { PersistGate } from "redux-persist/integration/react";
import App from "./App";
import { persistor, store } from "reduxStore/store";
import { useTheme, ThemeProvider } from "./ThemeContext";

const cache = createCache({
  key: "wis",
  //@ts-ignore
  container: document.querySelector('meta[name="global-style-insert"]'),
});

const domNode = document.getElementById("root");
//@ts-ignore
const root = createRoot(domNode);

const ThemeShell = () => {
  const { theme } = useTheme();
  return (
    <EuiProvider cache={cache} colorMode={theme}>
      <App />
    </EuiProvider>
  );
};

root.render(
  <JssProvider id={{ minify: false }}>
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        {/* @ts-ignore */}
        <ThemeProvider>
          <ThemeShell />
        </ThemeProvider>
      </PersistGate>
    </Provider>
  </JssProvider>
);
